export default "__VITE_ASSET__DzDLZo$l__"